export default __webpack_public_path__ + "static/media/YBDC.dbcc293b.JPG";